module.exports = __webpack_public_path__ + "static/rewards-card-banner-scorpion-c5b2e6e7f585f825ea4a29b77568a205.png";